import {
  REQUEST_COVID_MAIN_EXPERTS_SEARCH,
  RESPONSE_COVID_MAIN_EXPERTS_SEARCH,
  FAILURE_COVID_MAIN_EXPERTS_SEARCH,
  UPDATE_COVID_MAIN_EXPERTS_SEARCH_FILTER,
  TOGGLE_COVID_SAVE_MODE,
  UPDATE_COVID_SAVE_LIST_ITEMS,
  UPDATE_COVID_SAVE_LIST_TYPE,
  COVID_PROFESSIONALS_UPDATE_FILTER
} from "../../../actions/types";
import { defaultFilters } from "../_constants";

const initialState = {
  isInitialScreen: true,
  isFetching: false,
  results: [],
  error: false,
  activePage: 1,

  filters: defaultFilters,
  keyword: "",
  total: 0,
  isSaveActive: false,
  selectedItems: {},
  saveListType: "",

  totalArticles: 0,
  totalTrials: 0,
  advExperts: 0,
  total5YExperts: 0,
  totalCountries: 0
};

const setRequest = (state, action) => {
  let { keyword, filters, activePage } = action.payload;
  if (!filters) {
    filters = {
      year: "",
      country: [],
      partner: "false"
    };
  }

  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    keyword: keyword,
    filters,
    activePage,
    totalArticles: 0,
    total: 0,
    totalTrials: 0,
    advExperts: 0,
    total5YExperts: 0,
    totalCountries: 0
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: []
  };
};

const setResponse = (state, action) => {
  let {
    results = [],
    totalArticles,
    total,
    totalCountries,
    totalTrials,
    advExperts,
    total5YExperts
  } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isInitialScreen: false,
    totalArticles,
    total,
    total5YExperts,
    advExperts,
    totalCountries,
    totalTrials
  };
};

const setFilters = (state, action) => {
  let filters = action.payload.filters || defaultFilters;
  return {
    ...state,
    filters: filters
  };
};

const handleSaveToggle = (state, action) => {
  return {
    ...state,
    isSaveActive: !state.isSaveActive,
    selectedItems: {},
    saveListType: ""
  };
};

const handleUpdateSaveListItems = (state, action) => {
  let selectedItems = action.payload.selectedItems || {};
  return {
    ...state,
    selectedItems: selectedItems
  };
};

const updateSaveListType = (state, action) => {
  let saveListType = action.payload.saveListType;
  return {
    ...state,
    saveListType: saveListType
  };
};

const updateFilter = (state, action) => {
  let { filters } = action.payload;
  filters = filters || {};
  let { country, experts, listType, terms, year, university } = filters;

  let newFilters = {};
  if (country) {
    country = country || "";
    country = country
      .split(",")
      .filter(l => l)
      .map(l => ({
        label: l,
        value: l
      }));
    newFilters.location = country;
  }

  if (listType) {
    if (listType === "yes") {
      listType = "SHORT LIST";
      listType = {
        label: listType,
        value: "SHORT_LIST"
      };
    } else if (listType === "final") {
      listType = "FINAL LIST";
      listType = {
        label: listType,
        value: "FINAL_LIST"
      };
    } else if (listType === "no") {
      listType = "LONG LIST";
      listType = {
        label: listType,
        value: "LONG_LIST"
      };
    } else if (listType === "personal") {
      listType = "PERSONAL LIST";
      listType = {
        label: listType,
        value: "PERSONAL_LIST"
      };
    } else {
      listType = "LONG LIST";
      listType = {
        label: listType,
        value: "LONG_LIST"
      };
    }

    newFilters.listType = listType;
  }

  if (experts) {
    newFilters.experts = experts;
  }

  if (university) {
    newFilters.affs = university;
  }

  if (terms) {
    terms = terms || "";
    terms = terms
      .split(",")
      .filter(l => l)
      .map(l => ({
        label: l,
        value: l
      }));
    newFilters.topic = terms;
  }

  if(year) {
    newFilters.year = {
      label: year,
      value: year
    }
  }

  newFilters = {
    ...defaultFilters,
    ...newFilters
  };
  return {
    ...state,
    activePage: 1,
    filters: newFilters,
    from: 0
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_COVID_MAIN_EXPERTS_SEARCH:
      return setResponse(state, action);
      break;

    case FAILURE_COVID_MAIN_EXPERTS_SEARCH:
      return setFailure(state, action);
      break;

    case REQUEST_COVID_MAIN_EXPERTS_SEARCH:
      return setRequest(state, action);

    case UPDATE_COVID_MAIN_EXPERTS_SEARCH_FILTER:
      return setFilters(state, action);

    case TOGGLE_COVID_SAVE_MODE:
      return handleSaveToggle(state, action);

    case UPDATE_COVID_SAVE_LIST_ITEMS:
      return handleUpdateSaveListItems(state, action);

    case UPDATE_COVID_SAVE_LIST_TYPE:
      return updateSaveListType(state, action);

    case COVID_PROFESSIONALS_UPDATE_FILTER:
      return updateFilter(state, action);

    default:
      return state;
      break;
  }
};
